import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import collections from 'data/collections';
import { findCollection } from 'types/Collection';
import { useCollection } from 'utils/useCollection';

const withCollection =
  <P extends Record<string, string>>(WrappedComponent: React.ComponentType<P>): React.FC<P> =>
  ({ ...props }) => {
    const { collectionId } = useParams<{ collectionId?: string }>();
    const { collection, setCollection } = useCollection();

    useEffect(() => {
      const collectionFromParam = findCollection(collections, collectionId || '');
      setCollection(collectionFromParam, false);
    }, [collectionId, setCollection]);

    if (!collection) return null;

    const wrappedComponent = <WrappedComponent {...props} />;
    return wrappedComponent;
  };

export default withCollection;
